import {View, Text} from 'react-native';
import React from 'react';
import ImageHeaderModal from 'ImageHeaderModal';
import {customModalStyles, styles} from './ModalStyles';
import {
  WITHDRAWAL_ERROR_MODAL_DEFAULTS,
  WITHDRAWAL_ERROR_MODAL_TEST_IDS,
} from '../BankWithdrawalConstants';

type WithdrawalErrorModalProps = {
  onDismiss: () => void;
  bodyText?: string;
};

const WithdrawalErrorModal = ({onDismiss, bodyText}: WithdrawalErrorModalProps) => {
  return (
    <ImageHeaderModal
      title={WITHDRAWAL_ERROR_MODAL_DEFAULTS.title}
      buttonTextPrimary={WITHDRAWAL_ERROR_MODAL_DEFAULTS.buttonTextPrimary}
      imageHeader={WITHDRAWAL_ERROR_MODAL_DEFAULTS.icon}
      imageWidth={40}
      imageAspectRatio={1}
      backdropShadowEnabled={true}
      onPressPrimary={onDismiss}
      customStyles={customModalStyles}
      testIDs={WITHDRAWAL_ERROR_MODAL_TEST_IDS}
    >
      <View>
        <Text style={styles.bodyText}>{bodyText}</Text>
      </View>
    </ImageHeaderModal>
  );
};

export default WithdrawalErrorModal;
